// extracted by mini-css-extract-plugin
export default {"slider":"ClientSlider_slider__c7wzY","slideTrack":"ClientSlider_slideTrack__bFCsJ","scroll":"ClientSlider_scroll__O-RQx","slide":"ClientSlider_slide__xxNmO"};